import React, { useContext } from 'react';
import braintree from 'braintree-web';
import './BtnBuy.scss';
import { Context } from '../@context/Context';
import fetch from '../@helper/fetch/fetch';
import { getPlanSubscribe } from '../@helper/common/common';

const reqValues = [
    'cardName',
    'number',
    'expirationDate',
    'cvv',
    'postalCode',
];

const validateForm = (state) => {
    const err = {};
    const valid = reqValues.reduce((acc, item) => {
        const checkValue = state[item].length >= 3;
        Object.assign(err, { [item]: !checkValue });
        return (acc && checkValue);
    }, true);

    return {
        valid: valid && window.sessionStorage.getItem('accessToken'),
        err
    };
};


const parseErr = (details) => {
    const responseErr = details.reduce((acc, item) => {
        return Object.assign(acc, { [item.field]: true });
    }, {});
    return responseErr;
};

const onClick = (data, setLoader, setLastStep, setError, plan) => () => {
    const { creditCard: {
        cardName,
        number,
        expirationDate,
        cvv,
        billingAddress: {
            postalCode,
        }
    } } = data;

    const { valid, err: errForm } = validateForm({ cardName, number, expirationDate, cvv, postalCode });

    if (!valid) {        
        setError({ text: 'Highlighted field can not be empty.', type: 'braintree', show: true, body: errForm });
        return;
    }

    setLoader(true);
    braintree.client.create({
        authorization: window.sessionStorage.client_token
    }, (err, client) => {
        if (err) {
            setLoader(false);
            setError({ text: err.message, type: 'braintreeInit', show: true, body: err });
            return;
        }

        client.request({
            endpoint: 'payment_methods/credit_cards',
            method: 'post',
            data,
        }, (err, response) => {
            if (err) {                
                const visibleErr =err.details.originalError.error.message || err.message;
                const newErr = parseErr(err.details.originalError.fieldErrors[0].fieldErrors);
                setLoader(false);
                setError({ text: visibleErr, type: 'braintree', show: true, body: newErr });
                return;
            }
            getSubscribe(response.creditCards[0], setLoader, setLastStep, setError, plan);
        });
    });
};

const getSubscribe = (braintreeResponse, setLoader, setLastStep, setError, plan) => {
    const params = {
        payment_method_nonce: braintreeResponse.nonce,
        card_brand: braintreeResponse.details.cardType,
        card_last_four: braintreeResponse.details.lastFour
    };

    const url = '/users/me/braintree/subscriptions/' + plan;

    return fetch.post(url, params)
        .then((res) => {
            console.log(res);
            setLoader(false);
            setLastStep(true);
        }).catch(err => {
            setLoader(false);
            setError({ text: err.errors.messages, type: 'subscribe', show: true, body: err });
        });
};

const BtnBuy = () => {
    const {
        state: {
            cardName,
            cardNumber,
            expirationDate,
            cvv,
            postalCode,

        },
        actions: {
            setError,
            setLastStep,
            setLoader,

        } } = useContext(Context);

    const data = {
        creditCard: {
            cardName,
            number: cardNumber,
            expirationDate,
            cvv,
            billingAddress: {
                postalCode
            }
        }
    };

    const { plan, payBtn, description } = getPlanSubscribe();

    return (
        <div className="container container_center">
            <div>
                <button className="buy__btn" onClick={onClick(data, setLoader, setLastStep, setError, plan)}>{payBtn}</button>
                <div className="buy__text">
                    {description}
                </div>
            </div>
        </div>
    );
};

export default BtnBuy;